import defaultConfig from "./default";
import productionConfig from "./production";

const config = process.env.NODE_ENV === "production" ? productionConfig : defaultConfig;

export default config;
